import { Box, Button, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import i18n from "../language/i18n";
import { useRecoilState, useSetRecoilState } from "recoil";
import { infoModalAtom, unitsState } from "../state/state";
import { Units } from "../types/sharedTypes";

const LanguageSwitcher = () => {
  const { t } = useTranslation();
  const [units, setUnits] = useRecoilState(unitsState);
  const setInfoModal = useSetRecoilState(infoModalAtom);

  const switchLang = async (lang: string) => {
    i18n.changeLanguage(lang);
    const language = i18n.language;
    // Fetch info modal local first, then cloud if possible.
    const infoModalLocal = await fetch("/infoModal_" + language + ".md").then(
      (res) => res.text()
    );
    if (infoModalLocal) setInfoModal(infoModalLocal);
    fetch(process.env.REACT_APP_MODAL_URL + "_" + language + ".md")
      .then((res) => res.text())
      .then((res) => setInfoModal(res));
  };

  return (
    <Box fontWeight="bold" textAlign="right">
      <Box marginBottom="2">
        <Button
          variant="link"
          color={i18n.language === "de" ? "brand.red.500" : "black"}
          onClick={() => switchLang("de")}
        >
          {t("components.languageSwitcher.german")}
        </Button>
        <Text as="span"> | </Text>
        <Button
          variant="link"
          color={i18n.language === "en" ? "brand.red.500" : "black"}
          onClick={() => switchLang("en")}
        >
          {t("components.languageSwitcher.english")}
        </Button>
        <Text as="span"> | </Text>
        <Button
          variant="link"
          color={i18n.language === "fr" ? "brand.red.500" : "black"}
          onClick={() => switchLang("fr")}
        >
          {t("components.languageSwitcher.french")}
        </Button>
      </Box>
      <Box>
        <Button
          variant="link"
          color={units === Units.Metric ? "brand.red.500" : "black"}
          onClick={() => setUnits(Units.Metric)}
        >
          {t("components.languageSwitcher.met")}
        </Button>
        <Text as="span"> | </Text>
        <Button
          variant="link"
          color={units === Units.Imperial ? "brand.red.500" : "black"}
          onClick={() => setUnits(Units.Imperial)}
        >
          {t("components.languageSwitcher.imp")}
        </Button>
      </Box>
    </Box>
  );
};

export default LanguageSwitcher;
